import { fg_busy } from "@clockwise/design-system/tokens";
import { EmergencyHomeFilled } from "@clockwise/icons";
import { MagicWand } from "phosphor-react";
import React from "react";
import { SecondaryCard } from ".";
import { Item } from "./Item";

export const Break: React.FC<{ type: SecondaryCard }> = ({ children, type }) => {
  if (!children) {
    return null;
  }

  let Icon = null;
  switch (type) {
    case "sbm":
      Icon = <MagicWand weight="fill" color={fg_busy} className="cw-h-4 cw-w-4" />;
      break;
    case "unavailable":
      Icon = <EmergencyHomeFilled className="cw-text-warning-muted cw-h-4 cw-w-4" />;
      break;
  }

  return (
    <>
      <Item
        right={<div className="cw-body-sm cw-font-medium cw-py-2">{children}</div>}
        left={
          <div className="cw-w-8 cw-h-6 cw-bg-neutral cw-rounded-full cw-flex cw-items-center cw-justify-center">
            {Icon}
          </div>
        }
      />
    </>
  );
};
